// Wishlist via localStorage — sem login necessário
(function () {
  'use strict';

  const STORAGE_KEY = 'gdb_wishlist';

  // Lê a lista do localStorage
  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  // Salva a lista no localStorage
  function setWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      // Dispara evento global pra outros componentes saberem
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    } catch (e) {
      console.error('Erro ao salvar wishlist:', e);
    }
  }

  // Adiciona ou remove um produto
  function toggleProduct(handle) {
    if (!handle) return false;
    const list = getWishlist();
    const index = list.indexOf(handle);

    if (index === -1) {
      list.push(handle);
      setWishlist(list);
      return true; // adicionado
    } else {
      list.splice(index, 1);
      setWishlist(list);
      return false; // removido
    }
  }

  // Verifica se um produto está na wishlist
  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  // Atualiza visualmente todos os botões na página
  function syncButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(function (btn) {
      const handle = btn.getAttribute('data-product-handle');
      if (isInWishlist(handle)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remover dos favoritos');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Adicionar aos favoritos');
      }
    });
  }

  // Atualiza o contador no header
  function updateCounter() {
    const count = getWishlist().length;
    const counters = document.querySelectorAll('[data-wishlist-count]');
    counters.forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
    });
  }

  // Handler do clique no botão
  function handleClick(e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    toggleProduct(handle);
    syncButtons();
    updateCounter();
  }

  // Inicializa
  function init() {
    document.addEventListener('click', handleClick);
    syncButtons();
    updateCounter();
  }

  // Re-sincroniza quando algo muda em outra aba/componente
  window.addEventListener('wishlist:updated', function () {
    syncButtons();
    updateCounter();
  });

  // Re-sincroniza quando muda em outra aba do navegador
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      syncButtons();
      updateCounter();
    }
  });

  // Espera o DOM carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expõe API global pra ser usada em outros lugares (página de wishlist, etc)
  window.GDBWishlist = {
    get: getWishlist,
    set: setWishlist,
    toggle: toggleProduct,
    has: isInWishlist,
    clear: function () {
      setWishlist([]);
      syncButtons();
      updateCounter();
    },
    remove: function (handle) {
      const list = getWishlist();
      const idx = list.indexOf(handle);
      if (idx !== -1) {
        list.splice(idx, 1);
        setWishlist(list);
        syncButtons();
        updateCounter();
      }
    }
  };
})();